export default __webpack_public_path__ + "static/media/information--exit-ahead--g1.95953c4c.png";